import { SUGGESTION_STATUS, SUGGESTION_STATUS_VALUES } from '@Components/MatchComponents/v2/suggestion-status'
import React, { useContext, useEffect, useState } from 'react'
import { MatchSummary } from '@Entities/matching/MatchSummary'
import { StoresContext } from '@App/contexts'
import { getMatchSummary, getSongwriterMatchSummary } from '@App/api/routes/rightsholder/matching'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import StatusComponent from '@Components/Status'
import './index.scss'

const isMatchSummaryValid = (summary?: MatchSummary): boolean =>
    !!summary && !!(summary.submitted || summary.accepted || summary.rejected)

interface MatchHistoryStatusSectionProps {
    isSongwriterHub: boolean
}

const MatchHistoryStatusSection = ({ isSongwriterHub }: MatchHistoryStatusSectionProps) => {
    const { songwriterStore, rightsholderStore } = useContext(StoresContext)
    const [matchSummary, setMatchSummary] = useState<MatchSummary>()
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        if (isSongwriterHub) {
            getSongwriterMatchSummary(songwriterStore.currentSongwriterId).then((result) => {
                setMatchSummary(result.data)
                setIsLoading(false)
            })
        } else {
            getMatchSummary(rightsholderStore.currentRightsholderId).then((result) => {
                setMatchSummary(result.data)
                setIsLoading(false)
            })
        }
    }, [])

    return (
        <div className="dashboard-content-card match-history">
            <div className="match-history-title">
                Your Match History
                <CustomToolTip
                    info="Match History is a record of recent match suggestions that you've made for unmatched recording groups."
                    type="?"
                    inverse
                />
            </div>
            <div className="match-history-indicators">
                {isLoading ? (
                    <PointPreloader />
                ) : (
                    isMatchSummaryValid(matchSummary) && (
                        <div className="status-components-wrapper">
                            <StatusComponent
                                withCount
                                status={SUGGESTION_STATUS_VALUES[SUGGESTION_STATUS.SUBMITTED]}
                                big={false}
                                count={matchSummary?.submitted ?? 0}
                                circleFirst
                            />

                            <StatusComponent
                                withCount
                                status={SUGGESTION_STATUS_VALUES[SUGGESTION_STATUS.ACCEPTED]}
                                big={false}
                                count={matchSummary?.accepted ?? 0}
                                circleFirst
                            />

                            <StatusComponent
                                withCount
                                status={SUGGESTION_STATUS_VALUES[SUGGESTION_STATUS.PARTIALLY_ACCEPTED]}
                                big={false}
                                count={matchSummary?.partiallyAccepted ?? 0}
                                circleFirst
                            />

                            <StatusComponent
                                withCount
                                status={SUGGESTION_STATUS_VALUES[SUGGESTION_STATUS.REJECTED]}
                                big={false}
                                count={matchSummary?.rejected ?? 0}
                                circleFirst
                            />
                        </div>
                    )
                )}
            </div>
        </div>
    )
}

export default MatchHistoryStatusSection
